// src/Components/HelpMenu/HelpmenuData.js

export const helpMenuHeader = `
    <h3 class="help-menu-header">Help Menu</h3>
`;

export const version = `1.1.13-2026.4.02`;

export const helpMenuContent = `
    <div class="help-left-container">
        <h5 class="help-small-header">Mouse Interactions</h5>
        <ul class="left-content-list">
            <li>Select Item <span>Left Click</span></li>
            <li>Open Context Menu <span>Right Click</span></li>
            <li>Zoom In/Zoom Out <span>Scroll</span></li>    
            <li>Move Item <span>Left Click + Drag</span></li>
            <li>Delete Item <span>Left Click + Delete or Backspace</span></li>
            <li>Delete Item <span>Right Click + Delete Option</span></li>
            <li>Move Scene <span>Right Click + Hold</span></li>
        </ul>
    </div>
    <div class="help-right-container">
        <h5 class="help-small-header">Keyboard Interactions</h5>
        <ul class="left-content-list">
            <li>Select All <span>Ctrl + A / &#8984;+A</span></li>
            <li>Select Multiple <span>Ctrl + Left Click / &#8984;+ Left Click</span></li>
            <li>Copy <span>Ctrl + C / &#8984;+C</span></li>
            <li>Paste <span>Ctrl + V / &#8984;+V</span></li>
            <li>Rotate Right <span>Ctrl + R / &#8984;+R</span></li>
            <li>Rotate Left <span>Ctrl + L / &#8984;+L</span></li>
            <li>Top View <span> T </span></li>
            <li>Bottom View <span> B </span></li>
        </ul>
    </div>
`;
